import { render, staticRenderFns } from "./tags.vue?vue&type=template&id=4887bfb0"
import script from "./tags.ts?vue&type=script&lang=js&external"
export * from "./tags.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4887bfb0')) {
      api.createRecord('4887bfb0', component.options)
    } else {
      api.reload('4887bfb0', component.options)
    }
    module.hot.accept("./tags.vue?vue&type=template&id=4887bfb0", function () {
      api.rerender('4887bfb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/crud/templateWhatsApp/tags/tags.vue"
export default component.exports